import { render, staticRenderFns } from "./StallOrderDetail.vue?vue&type=template&id=c97ec938&scoped=true"
import script from "./StallOrderDetail.vue?vue&type=script&lang=js"
export * from "./StallOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./StallOrderDetail.vue?vue&type=style&index=0&id=c97ec938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97ec938",
  null
  
)

export default component.exports